import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const SelectedDocTypeActions = createActionGroup({
  source: 'Selected Doc Type',
  events: {
    'Set Selected Doc Type': props<{ selectedDocType: string }>(),
    'Clear Selected Doc Type': emptyProps(),
  },
});